import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

/**
 * When the user is signed in but email is not confirmed, redirect to verify-email.
 * Lets anonymous users through; pairs with authGuard on protected routes.
 */
export const emailVerifiedGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!auth.isAuthenticated) {
    return true;
  }

  const u = auth.getCurrentUser();
  if (u?.emailConfirmed === false) {
    router.navigate(['/verify-email'], { queryParams: { email: u.email } });
    return false;
  }
  if (u?.emailConfirmed === true) {
    return true;
  }

  return auth.refreshProfileFromServer().pipe(
    map(profile => {
      if (!profile || profile.emailConfirmed !== false) {
        return true;
      }
      router.navigate(['/verify-email'], { queryParams: { email: profile.email } });
      return false;
    }),
    catchError(() => of(true))
  );
};
